export default "__VITE_ASSET__BRu16mUn__"